import React, { Component } from 'react'
import { observer } from 'mobx-react'
import { Dropdown } from '@softwaredev_cegeka/stix-core'
import { Select } from '@softwaredev_cegeka/stix-form-select'
import { authenticatedUserStore } from '../../stores'
import AuthenticatedUserStore from '../../stores/AuthenticatedUserStore'

const { ORGANIZATION } = AuthenticatedUserStore.IMPERSONATE

class ImpersonateMenu extends Component {
    organizationData() {
        return authenticatedUserStore.userOrganizations.map(organization => ({
            value: organization.organization_id,
            label: organization.name,
            id: organization.id,
        }))
    }

    handleOrganizationChange(chosen) {
        if (!chosen && authenticatedUserStore.impersonated[ORGANIZATION]) {
            authenticatedUserStore.stopImpersonateOrganization()
        }
        if (chosen) {
            authenticatedUserStore.impersonateOrganization(chosen)
        }
    }

    render() {
        if (
            authenticatedUserStore.isLocalUser ||
            authenticatedUserStore.userOrganizations.length <= 1
        ) {
            return <></>
        }

        return (
            <div>
                <Dropdown.Divider />
                <Dropdown.Header>Change organization</Dropdown.Header>
                <Select
                    label={'Change organization'}
                    srOnly
                    options={this.organizationData()}
                    isSearchable
                    isClearable
                    menuIsOpen
                    onChange={this.handleOrganizationChange}
                    value={authenticatedUserStore.impersonated[ORGANIZATION]}
                    placeholder={'Filter organizations'}
                />
            </div>
        )
    }
}

ImpersonateMenu.propTypes = {}

export default observer(ImpersonateMenu)
